import * as actionTypes from "../actions";

const initialState = {
    hasMore: null,
    length: 0,
    isLoading: false,
    error: null,
    billList: {
        results: [],
        next: null,
        count: 0
    },
    gstDetail: '',
    linkedAssetList: {
        results: [],
        next: null,
        count: 0
    },
};


const billingReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.IS_BILL_LOADING:
            return {
                ...state,
                isLoading: true,
                error: null
            };
        // getUnique(state?.billList?.concat(action?.payload?.results), "customer") || []
        case actionTypes.BILL_LIST:
            const existingResults = state?.billList?.results || [];
            const incomingResults = action?.payload?.results || [];
        
            // Merge and deduplicate by `id`
            const combinedResults = [...existingResults, ...incomingResults];
            const uniqueResults = combinedResults.filter(
                (item, index, self) =>
                    index === self.findIndex((t) => t.id === item.id) // <-- use gst_number if id not available
            );
        
            return {
                ...state,
                isLoading: false,
                billList: {
                    ...action.payload,
                    results: uniqueResults,
                },
                hasMore: action?.payload?.next,
                length: action?.payload?.count,
            };

        case actionTypes.REQUEST_BILL_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };
        case actionTypes.CLEAR_BILLING_DATA:
            return {
                ...state,
                isLoading: true,
                billList: [],
                hasMore: null,
                length: 0
            };

        case actionTypes.GST_DETAIL:
            return {
                ...state,
                isLoading: false,
                gstDetail: action?.payload,
            };

        case actionTypes.LINKED_ASSET_LIST:
            return {
                ...state,
                isLoading: false,
                linkedAssetList: {
                    ...action.payload,
                    // results: [...(state.linkedAssetList.results || []), ...(action.payload.results || [])]
                }
            };


        default:
            return state;
    }
};

export default billingReducer;